import React from "react";

export default function Mongo() {
  return (
    <div>
      <svg
        width="48"
        height="80"
        viewBox="0 0 48 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_5388_6682)">
          <path
            d="M23.9906 0C25.9465 2.49488 27.7116 4.853 29.589 7.11871C34.4919 13.0288 39.1105 19.1126 42.4426 26.0761C50.9768 43.9246 49.8025 61.0265 38.1194 77.1009C35.1388 81.2036 31.1597 84.5929 27.7004 88.3667C27.132 88.9876 26.657 89.871 26.5486 90.6842C26.1746 93.4858 26.0063 96.3096 25.7034 99.1224C25.5987 100.083 25.5164 101 24.0055 101C22.5096 101 22.3937 100.109 22.289 99.1409C21.9861 96.3318 21.8178 93.5043 21.44 90.7063C21.3316 89.8969 20.8903 88.9433 20.2807 88.4184C10.2058 79.7621 3.05906 69.3354 0.691783 56.1735C-0.987375 46.8556 0.478616 37.8223 4.13238 29.0995C7.60662 20.8091 12.8685 13.683 18.6315 6.85259C20.449 4.69776 22.1132 2.41356 23.9906 0.00369611V0ZM24.1701 36.0334C24.0429 36.0334 23.912 36.0371 23.7849 36.0408C23.7138 36.3291 23.5942 36.6137 23.5829 36.9057C23.4296 40.5279 23.3099 44.1538 23.1416 47.776C22.835 54.2811 22.4947 60.7863 22.1768 67.2914C21.8926 73.1239 21.6308 78.9564 21.3241 84.7888C21.2344 86.4964 22.36 87.6127 23.6129 88.0045C24.2785 88.2114 25.5912 87.073 26.2905 86.2673C26.7131 85.7757 26.6234 84.7593 26.586 83.9831C26.2831 77.4779 25.9128 70.9728 25.6136 64.4676C25.1948 55.3197 24.8208 46.1682 24.4132 37.0203C24.3982 36.6876 24.2561 36.3624 24.1701 36.0297V36.0334Z"
            fill="#1EE070"
          />
        </g>
        <defs>
          <clipPath id="clip0_5388_6682">
            <rect width="48" height="101" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
